<!--  -->
<template>
  <div class="QuestionList">
    <div class="question-main">
      <div class="question-title">
        <h1>{{title}}</h1>
        <span @click="openAll()"
          >{{qbzk}} <img src="../../assets/down.png"
        /></span>
      </div>
      <ul class="question-list">
        <li v-for="(item, index) in questionList" :key="index">
          <div
            class="li-title"
            @click="openFunc(index), (item.flag = !item.flag)"
          >
            <img
              :class="{
                arrowTransform: !item.flag,
                arrowTransformReturn: item.flag,
              }"
              src="../../assets/questioSanjiao.png"
            />
            &nbsp; {{ item.title }}
          </div>
          <div class="fenge"></div>
          <div class="p" ref="liCon">
            <p>{{ item.msg }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      title:"",
      qbzk:"",
      flag: false,
      liConHeight: 0,
      questionList: [
        /* 
        {
          title: "我怎么能租一辆小汽车或卡车呢?",
          msg: "您可以通过我们的网站www.Avis.com, www.Budget.com, wwwzipcar.com, www.paylesscar.comm http://www.apexrentocar.com.au/或www租车。或者拨打我们的réservation中心免费电话:Avis电话1-888-777-AVIS, Budget电话1-800BUDGET7或Budget Truck电话1-800- go - Budget town在Avis欧洲我的股份怎么了?",
          flag: false,
        },
        {
          title: "我怎么能租一辆小汽车或卡车呢?",
          msg: "您可以通过我们的网站www.Avis.com, www.Budget.com, wwwzipcar.com, www.paylesscar.comm http://www.apexrentocar.com.au/或www租车。或者拨打我们的réservation中心免费电话:Avis电话1-888-777-AVIS, Budget电话1-800BUDGET7或Budget Truck电话1-800- go - Budget town在Avis欧洲我的股份怎么了?",
          flag: false,
        },
        {
          title: "我怎么能租一辆小汽车或卡车呢?",
          msg: "您可以通过我们的网站www.Avis.com, www.Budget.com, wwwzipcar.com, www.paylesscar.comm http://www.apexrentocar.com.au/或www租车。或者拨打我们的réservation中心免费电话:Avis电话1-888-777-AVIS, Budget电话1-800BUDGET7或Budget Truck电话1-800- go - Budget town在Avis欧洲我的股份怎么了?",
          flag: false,
        },
       */
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    openFunc(i) {
      const liCon = this.$refs.liCon[i];
      let height = liCon.offsetHeight;
      if (height === this.liConHeight) {
        // 展开
        liCon.style.height = "auto";
        height = liCon.offsetHeight;
        liCon.style.height = this.liConHeight + "px";
        let f = document.body.offsetHeight;
        liCon.style.height = height + "px";
      } else {
        // 收缩
        liCon.style.height = this.liConHeight + "px";
      }
    },
    openAll() {
      const that = this;
      //箭头翻转
      this.questionList.forEach((element) => {
        element.flag = !element.flag;
      });
      const liCon = this.$refs.liCon;
      liCon.forEach((element) => {
        let height = element.offsetHeight;
        if (height === that.liConHeight) {
          element.style.height = "auto";
          height = element.offsetHeight;
          element.style.height = that.liConHeight + "px";
          let f = document.body.offsetHeight;
          element.style.height = height + "px";
        } else {
          // 收缩
          element.style.height = that.liConHeight + "px";
        }
      });
    },
    get_data() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: 43,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.title = obj.yj_name;
            $.each(obj.data, function (i, k) {
              that.questionList.push({
                title: k.title,
                msg: k.msgs,
                flag: false,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.qbzk = obj.data["qbzk"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_data();
    this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.QuestionList {
  width: 100%;
  .question-main {
    width: $main-width;
    margin: 0 auto;
    .question-title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      h1 {
        font-size: 1.2rem;
        color: #2d2d2d;
      }
      span {
        font-size: 0.9rem;
        color: #0069b5;
      }
    }
    .question-list {
      width: 100%;
      margin-top: 30px;
      li {
        .fenge {
          margin: 30px 0;
          width: 100%;
          height: 1px;
          background: #999999;
          opacity: 0.5;
        }
        .li-title {
          display: inline-block;
          font-size: 1.2rem;
          color: #00a1ff;
          vertical-align: middle;
          cursor: pointer;
        }
        .p {
          height: 0px;
          overflow: hidden;
          transition: height 0.3s;
          p {
            display: inline-block;
            padding-bottom: 30px;
            color: #2d2d2d;
            font-size: 1rem;
            border-bottom: 1px solid rgba(153, 153, 153, 0.5);
            margin-bottom: 30px;
          }
        }
      }
    }
  }
  .arrowTransform {
    transition: 0.2s;
    transform-origin: center;
    transform: rotateZ(0deg);
  }
  .arrowTransformReturn {
    transition: 0.2s;
    transform-origin: center;
    transform: rotateZ(90deg);
  }
}
@media screen and (max-width: $main-width) {
  .QuestionList {
    padding: 0 10px;
    .question-main {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/investor/QuestionList.vue